import { create } from "zustand";
import { applyAnalyticsConsent, saveConsent } from "../utils/privacyConsent";

const useConsentStore = create((set, get) => ({
  bannerVisible: false,
  preferencesOpen: false,
  analytics: true,
  doNotSell: false,
  consentGiven: false,
  gpcDetected: false,

  setFromResolvedConsent: (resolved) => {
    set({
      bannerVisible: resolved.bannerVisible,
      analytics: resolved.analytics,
      doNotSell: resolved.doNotSell,
      consentGiven: resolved.consentGiven,
      gpcDetected: resolved.gpcDetected,
    });
  },

  acknowledgeBanner: (posthog) => {
    const { gpcDetected } = get();
    const analytics = !gpcDetected;
    const consent = saveConsent({
      consentGiven: true,
      analytics,
      doNotSell: !analytics,
      gpcDetected,
    });

    applyAnalyticsConsent(posthog, analytics);
    set({
      ...consent,
      bannerVisible: false,
      preferencesOpen: false,
    });
  },

  optOutAnalytics: (posthog) => {
    const consent = saveConsent({
      consentGiven: true,
      analytics: false,
      doNotSell: true,
      gpcDetected: get().gpcDetected,
    });

    set({
      ...consent,
      bannerVisible: false,
      preferencesOpen: false,
    });

    applyAnalyticsConsent(posthog, false);
  },

  savePreferences: (posthog, { analytics }) => {
    const consent = saveConsent({
      consentGiven: true,
      analytics,
      doNotSell: !analytics,
      gpcDetected: get().gpcDetected,
    });

    set({
      ...consent,
      bannerVisible: false,
      preferencesOpen: false,
    });

    applyAnalyticsConsent(posthog, analytics);
  },

  openPreferences: () => set({ preferencesOpen: true, bannerVisible: false }),
  closePreferences: () => set({ preferencesOpen: false }),
  dismissBanner: () => set({ bannerVisible: false }),
}));

export default useConsentStore;
